module.exports = __webpack_public_path__ + "media/images/early-music-3-a90c3669f1c2b455d9270ed7af4a7a36.jpg";